'use strict';
var parent = require('../../stable/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/array/from.js
// module id = 328
// module chunks = 0